//this function will return
// 1 if the versionOne is greater than versionTwo in semantic versioning sense. and
// will return -1 if the versionTwo is greater than the versionOne.
// and will return 0 if both the versions are same.

export default function compareSemanticVersions(versionOne: string, versionTwo: string) {
    if (versionOne === versionTwo) {
        return 0;
    }

    const versionOneComponents = versionOne.split(".");
    const versionTwoComponents = versionTwo.split(".");

    //take min length of both strings to avoid overflow issues.
    const len = Math.min(versionOneComponents.length, versionTwoComponents.length);

    for (let i = 0; i < len; i++) {
        // versionTwo bigger than versionTwo
        if (parseInt(versionOneComponents[i]) > parseInt(versionTwoComponents[i])) {
            return 1;
        }

        // versionTwo bigger than versionTwo
        if (parseInt(versionOneComponents[i]) < parseInt(versionTwoComponents[i])) {
            return -1;
        }
    }

    if (versionOneComponents.length > versionTwoComponents.length) {
        return 1;
    }

    if (versionOneComponents.length < versionTwoComponents.length) {
        return -1;
    }

    return 0;
}
